import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class SingleDesigner2021 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,

			designerLocation: null,
		};

		this.designerData = {
			'atx': {
				url: 'austin', 
				designer: 'Verragio', 
				week: 3,
			},
			'bhm': {
				url: 'birmingham', 
				designer: 'Tacori', 
				week: 2,
			},
			'boc': {
				url: 'boca-raton', 
				designer: 'Tacori', 
				week: 3,
			},
			'chs': {
				url: 'charleston', 
				designer: 'Verragio', 
				week: 2,
			},
			'cle': {
				url: 'cleveland', 
				designer: 'Classique', 
				week: 3,
			},
			'clt': {
				url: 'charlotte', 
				designer: 'Tacori', 
				week: 3,
			},
			'coh': {
				url: 'columbus', 
				designer: 'SimonG', 
				week: 2,
			},
			'dfw': {
				url: 'dallas', 
				designer: 'Verragio', 
				week: 2,
			},
			'ftx': {
				url: 'frisco', 
				designer: 'Verragio', 
				week: 2,
			},
			'gsc': {
				url: 'greenville', 
				designer: 'SimonG', 
				week: 3,
			},
			'hou': {
				url: 'houston', 
				designer: 'Tacori', 
				week: 3,
			},
			'ind': {
				url: 'indianapolis', 
				designer: 'Verragio', 
				week: 2,
			},
			'jax': {
				url: 'jacksonville', 
				designer: 'Tacori', 
				week: 2,
			},
			'kcy': {
				url: 'kansas-city', 
				designer: 'SimonG', 
				week: 3,
			},
			'okc': {
				url: 'oklahoma-city', 
				designer: 'Amden', 
				week: 3,
			},
			'pit': {
				url: 'pittsburgh', 
				designer: 'SimonG', 
				week: 1,
			},
			'ral': {
				url: 'raleigh', 
				designer: 'Verragio', 
				week: 1,
			},
			'rva': {
				url: 'richmond', 
				designer: 'SimonG', 
				week: 3,
			},
			'stl': {
				url: 'st-louis', 
				designer: 'Tacori', 
				week: 1,
			},
			'san': {
				url: 'san-antonio', 
				designer: 'Verragio', 
				week: 3,
			},
			'vab': {
				url: 'virginia-beach', 
				designer: 'Verragio', 
				week: 2,
			},
		}

		this.designerLocationArray = [
			{
				display: 'Select Location',
				value: '',
			},
	    	{
				display: 'Austin, TX',
				value: 'atx',
			},
			{
				display: 'Birmingham, AL',
				value: 'bhm',
			},
			{
				display: 'Boca Raton, FL',
				value: 'boc',
			},
			{
				display: 'Charleston, SC',
				value: 'chs',
			},
			{
				display: 'Charlotte, NC',
				value: 'clt',
			},
			{
				display: 'Cleveland, OH',
				value: 'cle',
			},
			{
				display: 'Columbus, OH',
				value: 'coh',
			},
			{
				display: 'Dallas, TX',
				value: 'dfw',
			},
			{
				display: 'Frisco, TX',
				value: 'ftx',
			},
			{
				display: 'Greenville, SC',
				value: 'gsc',
			},
			{
				display: 'Houston, TX',
				value: 'hou',
			},
			{
				display: 'Indianapolis, IN',
				value: 'ind',
			},
			{
				display: 'Jacksonville, FL',
				value: 'jax',
			},
			{
				display: 'Kansas City, KS',
				value: 'kcy',
			},
			{
				display: 'Oklahoma City, OK',
				value: 'okc',
			},
			{
				display: 'Pittsburgh, PA',
				value: 'pit',
			},
			{
				display: 'Raleigh, NC',
				value: 'ral',
			},
			{
				display: 'Richmond, VA',
				value: 'rva',
			},
			{
				display: 'St. Louis, MO',
				value: 'stl',
			},
			{
				display: 'San Antonio, TX',
				value: 'san',
			},
			{
				display: 'Virginia Beach, VA',
				value: 'vab',
			},
		];
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  changeDesignerLocation(evt) {
  	this.setState({
  		designerLocation: evt.target.value,
  	})
  }

  getFirstDay() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].week) {
  		case 1:
  			return 'Friday, Sept 10';
  		case 2:
  			return 'Friday, Sept 17';
  		case 3:
  			return 'Friday, Sept 24';
  	}
  	return '';
  }

  getSecondDay() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].week) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].week) {
  		case 1:
  			return 'Saturday, Sept 11';
  		case 2:
  			return 'Saturday, Sept 18';
  		case 3:
  			return 'Saturday, Sept 25';
  	}
  	return '';
  }

  getDesignerImg() {
  	if(!this.state.designerLocation || !this.designerData[this.state.designerLocation].designer) {
  		return '';
  	}

  	switch(this.designerData[this.state.designerLocation].designer) {
  		case 'SimonG':
  			return 'simong.svg';
  		case 'Amden':
  			return 'amden.png';
  		case 'Classique':
  			return 'classique.svg';
  		case 'Tacori':
  			return 'tacori.svg';
  		case 'Verragio':
  			return 'verragio.svg';
  	}
  	return '';
  }

	render() {
		return <div className='SingleDesigner2021'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/header.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/headerm.jpg" alt="Diamonds Direct" />
				<div className='headerSelectWrapper'>
					<RhinoSelect
						selectClass={'singleSelect'}
						value={this.state.designerLocation}
						options={this.designerLocationArray}
						changeMethod={(evt) => this.changeDesignerLocation(evt)} />
				</div>
			</div>
			<div className='designersWrapper'>
				<div className='designerBlock'>
					
					<div className='designerBanner'>
						{this.state.designerLocation ?
							<img src={'https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/' + this.getDesignerImg()} /> :
							null
						}
					</div>

					{this.state.designerLocation ?
						<div className={'designerDisplay'}>
							<div className='daysWrapper'>
								<div className='dayBlock'>
									<div className='dayValue'>{this.getFirstDay()}</div>
									<div className='timeValue'>10 a.m. - 7 p.m.</div>
								</div>
								<div className='dayBlock'>
									<div className='dayValue'>{this.getSecondDay()}</div>
									<div className='timeValue'>10 a.m. - 7 p.m.</div>
								</div>
							</div>
						</div> :
						null
					}
				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>

			<div className='boxSection'>
				<div className='fuImage'>
					<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/madetolast.svg" alt="Diamonds Direct" />
				</div>
				<div className='fuP'>Let the special someone in your life know that your love is forever with our Made to Last September Financing Event!</div>
				<div className='fuP'>Shop with us online or in-store and take advantage of:</div>
				<div className='fuBox'>
					<div className='box1'>0% APR for 5 Years*</div>
					<div className='box2'>Subject to credit approval.</div>
					<div className='box3'>Available August 30 - October 2</div>
					<div className='boxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}><div>Ready to Apply</div></div>
				</div>
				<div className='fuLegal'>*The Wells Fargo Jewelry Advantage® credit card is issued by Wells Fargo Bank, N.A. Special terms for 5 years (60 months) apply to qualifying purchases charged with approved credit. The special terms APR will continue to apply until all qualifying purchases are paid in full. The monthly payment for this purchase will be the amount that will pay for the purchase in full in equal payments during the promotional (special terms) period. The APR for purchases will apply to certain fees such as a late payment fee or if you use the card for other transactions. For new accounts, the APR for Purchases is 28.99%. If you are charged interest in any billing cycle, the minimum interest charge will be $1.00. This information is accurate as of 08/01/2021 and is subject to change. For current information, call us at 1-800-431-5921. Offer valid 08/30/2021 till 10/2/2021.</div>
			</div>

			<div className='imagesSection'>
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/jewelry.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/singledesigner2021/landing/jewelrym.jpg" alt="Diamonds Direct" />
				<div className={'img1 imgLink'} onClick={() => this.internalNav('setting/SMD1450915')}></div>
				<div className={'img2 imgLink'} onClick={() => this.internalNav('jewelry/TACSS00087')}></div>
				<div className={'img3 imgLink'} onClick={() => this.internalNav('jewelry/BLDXL08952')}></div>
				<div className={'img4 imgLink'} onClick={() => this.internalNav('setting/SMD1810217')}></div>
				<div className={'img5 imgLink'} onClick={() => this.internalNav('jewelry/EFAND12750')}></div>
			</div>

		</div>;
	}
}
export default SingleDesigner2021;

function mapStateToProps(state) {
  return {

  };
}

export const SingleDesigner2021Container = connect(
  mapStateToProps,
  allActionCreators
)(SingleDesigner2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/singledesigner2021/SingleDesigner2021.jsx